<template>
    <div class="reservation">
        <HandMenu/>
        <el-card shadow="never" style="border: 0;border-right: 1px solid #EBEEF5;">
            <el-row :gutter="20">
                <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>当前位置</el-breadcrumb-item>
                </el-breadcrumb>
                <div v-loading="loading">
                    <el-col style="margin-bottom: 10px" :xs="24" :sm="12" :md="8" :lg="5" :xl="4">
                        <el-input placeholder="搜索参展人员名字" v-model="reservationName"
                                  class="input-with-select">
                        </el-input>
                    </el-col>
                    <el-col style="margin-bottom: 10px" :xs="24" :sm="24" :md="24" :lg="9" :xl="12">
                        <el-button type="primary" @click="selectTable" plain>搜索</el-button>
                        <el-button type="success" @click="clearSelect" plain>清空</el-button>
                        <el-button type="info" @click="refreshTable" plain>刷新</el-button>
                    </el-col>
                    <el-table
                            :data="tableData"
                            border
                            :header-cell-style="cellStyle"
                            :cell-style="cellStyle"
                            style="width: 100%">
                        <el-table-column
                                fixed
                                type="index"
                                label="#"
                                width="50"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="reservationUserName"
                                label="预约人"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="reservationPeopleNumber"
                                label="预约人数"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="reservationTime"
                                label="预约时间"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="reservationPhone"
                                label="手机号"
                        >
                        </el-table-column>
                        <el-table-column
                                label="处理状态"
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.reservationState===1">已处理</span>
                                <span v-else>待处理</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="150">
                            <template slot-scope="scope">
                                <el-button slot="reference" type="text" size="small"
                                           v-if="scope.row.reservationState!==1"
                                           @click="changeReservationState(scope.row)">处理完成
                                </el-button>
                                <!--删除内容的按钮-->
                                <el-popconfirm
                                        style="margin-left: 10px;"
                                        icon="el-icon-info"
                                        iconColor="red"
                                        title="删除后将无法恢复,请确认！"
                                        @onConfirm="deleteRoleInf(scope.row)"
                                >
                                    <el-button slot="reference" type="text" size="small">删除</el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--分页器-->
                    <div class="block" style="margin-top: 10px;text-align: right">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[5, 10, 20, 30]"
                                :page-size="10"
                                layout="prev, pager, next, jumper,sizes"
                                :total="reservationTotal">
                        </el-pagination>
                    </div>
                </div>
            </el-row>
        </el-card>
    </div>
</template>

<script>
    import axios from "../../api";
    import Vue from "../../main";

    export default {
        name: "ReservationManager",
        data() {
            return {
                //搜索框
                reservationName: "",
                //表格内容
                tableData: [],
                //加载遮罩层
                loading: false,
                //-------------分页器 --------
                // 当前页数
                currentPage: 1,
                //分页器 每页显示几条
                pageSize: 10,
                //总共有多少条数据
                reservationTotal: 0,
            }
        },
        methods: {
            //分页器 当前每页几条
            handleSizeChange(val) {
                this.loading = true;
                this.pageSize = val;
                this.getTableData();
            },
            //分页器当前在第几页
            handleCurrentChange(val) {
                this.loading = true;
                this.currentPage = val;
                this.getTableData();
            },
            cellStyle({columnIndex}) {
                //让序号那一列居中
                if (columnIndex === 0) {
                    // 指定列号
                    return 'text-align: center;'
                } else {
                    return ''
                }
            },
            //刷新表格
            refreshTable() {
                //获取内容
                this.getTableData();
            },
            //搜索
            selectTable() {
                //设置当前页为1
                this.currentPage = 1;
                //获取内容
                this.getTableData();
            },
            //清除搜索框
            clearSelect() {
                this.reservationName = "";
            },
            //获取表格内容
            getTableData() {
                let self = this;
                axios.getReservationTable({
                    //当前页
                    page: self.currentPage,
                    //每页显示几条
                    showCount: self.pageSize,
                    reservationName: self.reservationName
                }).then(res => {
                    console.log(res.data.reservationList.records)
                    self.tableData = res.data.reservationList.records;
                    //设置总页数
                    self.reservationTotal = res.data.reservationList.total;

                })
            },
            changeReservationState(row){
                let self =this;
                axios.changeReservationState({
                    id:row.reservationId
                }).then(res=>{
                   if (res.data.state==="success"){
                       Vue.$message({
                           message: "处理完成！",
                           duration: 1500,
                           type: "success"
                       });
                       //获取内容
                       self.getTableData();
                   } else {
                       Vue.$message({
                           message: "出现意外错误，请联系开发人员！",
                           duration: 1500,
                           type: "error"
                       });
                   }
                })
            }
        },
        mounted() {
            this.getTableData();
        }
    }
</script>

<style scoped>
    .reservation {
        flex: 1;
        overflow: auto;
        width: 100%;
        border: 0;
    }
</style>
